import React, { useState, useRef, useContext } from 'react';
import { usePersistedState } from '../../../hooks'
import EmpresaContext from "../../../contexts/Empresa";
import { AxiosResponse } from 'axios';
import { useHistory } from "react-router-dom";
import api from "../../../services/api";
//@ts-ignore
import NotificationAlert from "react-notification-alert";
import Filters from './Filters'

import { Notificacao } from '../../../entities/Security';

import Table from './Table';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
// core components
import SimpleHeader from '../../../components/Headers/SimpleHeader'
//@ts-ignore
let cancelApi = undefined

const Notificacoes: React.FC = ({ }) => {

  const history = useHistory()
  const { empresaSelecionada } = useContext(EmpresaContext)
  const [loading, setLoading] = useState(false)
  const [alert, setAlert] = useState(null)
  const [notificacoes, setNotificacoes] = useState(new Array<Notificacao>())

  const [lastSearch, setLastSearch] = usePersistedState('lastSearchNotificacao', {})
  const [currentPage, setCurrentPage] = usePersistedState('page', 1)
  const [currentPerPage, setCurrentPerPage] = usePersistedState('perPage', 10)
  const [currentSortField, setCurrentSortField] = usePersistedState('sortFieldNotificacao', 'sended_at')
  const [currentSortOrder, setCurrentSortOrder] = usePersistedState('sortOrderNotificacao', 'desc')
  const [headerContent, setHeaderContent] = useState<any>(null);
  const [showConfirmAll, setShowConfirmAll] = useState(false);
  const [pageProperties, setPageProperties] = useState({
    total: "0",
    perPage: currentPerPage,
    page: currentPage,
    lastPage: 1,
    loading: false,
    sort: new Map([])
  })


  const notificationAlert = useRef<NotificationAlert>(null);

  function notify(type: string, msg: string) {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span data-notify="message">
            {msg}
          </span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 7
    };
    if(notificationAlert?.current) {
      notificationAlert.current.notificationAlert(options);
    }
  };

  async function updatePageProperties(response: AxiosResponse) {
    const { total, perPage, page, lastPage } = await response.data
    setPageProperties({
      ...pageProperties,
      total,
      perPage,
      page,
      lastPage,
      loading: false,
    })
  }

  async function loadNotificacoes(page = 1,
    limit = 10,
    sortField = "sended_at",
    sortOrder = "desc",
    filters = lastSearch) {

    setLoading(true)
    setCurrentPage(page)
    setCurrentPerPage(limit)
    setCurrentSortField(sortField)
    setCurrentSortOrder(sortOrder)

    try {
      setPageProperties({
        ...pageProperties,
        loading: true
      })
      const response = await api.get(`/security/notificacoes/getByVarious`, {
        params: {
          page,
          limit,
          sortField,
          sortOrder,
          ...filters
        }
      })
      setNotificacoes(response.data.data)
      await updatePageProperties(response)
    } catch (err) {
      //@ts-ignore
      console.log(err.response)
      notify('danger', 'Houve um problema ao carregar as Notificações.');
    }
    setLoading(false)
  }

  async function handleTableChange(type: string, sortProperties: { page: number, sizePerPage: number, sortField: string, sortOrder: string }): Promise<void> {
    try {

      if (type == 'sort') {
        sortProperties.sortField = sortProperties.sortField.replace('__meta__.', '')
        const value = pageProperties.sort.get(sortProperties.sortField)
        const newOrder = (value || 'asc') == 'desc' ? 'asc' : 'desc'
        const map = pageProperties.sort
        map.set(sortProperties.sortField, newOrder)
        sortProperties.sortOrder = newOrder
        setCurrentSortField(sortProperties.sortField)
        setCurrentSortOrder(sortProperties.sortOrder)
      } else if (type == 'pagination') {
        sortProperties.sortField = currentSortField
        sortProperties.sortOrder = currentSortOrder
      }

      //@ts-ignore
      if (cancelApi) {
        try {
          //@ts-ignore
          cancelApi.cancel('Request canceled')
        } catch (error) {
        }
      }

      await loadNotificacoes(
        sortProperties.page == 0 ? 1 : sortProperties.page,
        sortProperties.sizePerPage,
        sortProperties.sortField,
        sortProperties.sortOrder)
    } catch (error) {
      notify('danger', 'Houve um problema ao carregar as Notificações.');
    }
  }

  async function reload() {
    loadNotificacoes(
      currentPage ? currentPage : 1,
      currentPerPage ? currentPerPage : 10,
      currentSortField ? currentSortField: "sended_at",
      currentSortOrder ? currentSortOrder : "desc",
      lastSearch)
  }

  async function marcarTodasLidas() {
    try {
      const { data } = await api.put(`/security/notificacoes/todas-lidas`);
      reload();
      notify(
        "success",
        `${data.totalAtualizadas} notificações marcadas como lidas.`
      );
    } catch (error: any) {
      notify("danger", error.response?.data?.message || 'Erro ao marcar todas como lidas');
    }
  }

  return (
    <>
      {alert}
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>

      <Modal
        isOpen={showConfirmAll}
        toggle={() => setShowConfirmAll(false)}
        centered
      >
        <div className="modal-header">
           <h5 className="modal-title">Confirmar ação</h5>
           <button
              aria-label="Close"
              className="close"
              type="button"
              onClick={() => setShowConfirmAll(false)}
            >
              <span aria-hidden={true}>×</span>
            </button>
        </div>
        <ModalBody>
          Tem certeza que deseja marcar <strong>todas</strong> as notificações
          como lidas?
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            size="sm"
            onClick={() => setShowConfirmAll(false)}
          >
            Cancelar
          </Button>
          <Button
            color="primary"
            size="sm"
            onClick={async () => {
              await marcarTodasLidas();
              setShowConfirmAll(false);
            }}
          >
            Sim, marcar todas
          </Button>
        </ModalFooter>
      </Modal>

      <SimpleHeader name="Listagem de Notificações" parentName="Notificações" />
      <div className="w-100">
        <Row>
          <Col>
            <Card>
              <CardHeader>
                {headerContent ? headerContent : (
                   <div className="d-flex justify-content-between align-items-center">
                    <h1 className="mb-0">Notificações</h1>
                   </div>
                )}
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <Filters
                      setHeaderContent={setHeaderContent}
                      title={<h1>Notificações</h1>}
                      data={notificacoes}
                      notify={notify}
                      isActive={true}
                      openConfirmAll={() => setShowConfirmAll(true)}
                      load={async (filters: object, clearPagination: boolean, clearSort: boolean) => {
                        setLastSearch(filters)
                        loadNotificacoes(
                          clearPagination ? 1 : currentPage,
                          clearPagination ? 10 : currentPerPage,
                          clearSort ? "sended_at" : currentSortField,
                          clearSort ? "desc" : currentSortOrder,
                          filters)
                      }}
                    />
                    <Table
                      notificacoes={notificacoes || []}
                      notify={notify}
                      onTableChange={handleTableChange}
                      pageProperties={pageProperties}
                      loading={loading}
                      reload={reload}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default Notificacoes;